module.exports = __webpack_public_path__ + "img/banner.5f05e5be.jpg";